module.exports = __webpack_public_path__ + "static/media/ical.ef200ce7.png";